import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Select } from 'components/Wizard2/fieldComponents/Form'
import Table from '../Table/Table'
import format from 'date-fns/format'
import { Spinner } from '../Loaders/Loaders'
import {
  GET_WEB_USER_ACCESS_LIST,
  REJECT_RECORD_ACCESS_REQUEST,
  ACCEPT_RECORD_ACCESS_REQUEST,
  REVOKE_RECORD_ACCESS,
  SET_WEB_USER_ACCESS_LEVEL
} from '../../requests'
import { ConfirmDialog } from '../Modal/Modal'
import Portal from 'components/Portal/Portal'
import { noop } from 'utilities'
import ReactTooltip from "react-tooltip"

const USER_ACCESS_LEVEL_MANAGEMENT = process.env.USER_ACCESS_LEVEL_MANAGEMENT
const ALLOW_REVOKE_OWN_ACCESS_ONLY = process.env.ALLOW_REVOKE_OWN_ACCESS_ONLY
const SHOW_ACCESS_LEVEL_TYPE_DROPDOWN = process.env.SHOW_ACCESS_LEVEL_TYPE_DROPDOWN

class Ownership extends Component {
  constructor() {
    super()
    this.state = {
      owners: null,
      revokeDialogOpen: false,
      revokingName: '',
      revokingOwnAccess: false,
      revokingId: null,
      error: null,
      accessSelectDisabled: true,
      currentOwnerAccessLevel: null
    }
  }
  componentDidMount = () => {
    this.getWebUserAccessList()
  }
  getWebUserAccessList = () => {
    GET_WEB_USER_ACCESS_LIST(this.props.category, this.props.source_id, owners => {
      this.setState({
        owners: this.formatOwnersForTableRows(owners),
        accessSelectDisabled: false,
        currentOwnerAccessLevel: (
          owners.find(x => x.WEB_USER_ID === this.props.currentUserId) || {}
        ).WEB_USER_ACCESS_LEVEL_TYPE_ID
      })
    })
  }
  formatOwnersForTableRows = owners => {
    return owners.map((owner, i) => ({
      ...owner,
      TYPE: owner.STATUS,
      RECORD_ID: owner.WEB_USER_ACCESS_ID,
      LAST_MODIFIED_DATE: format(new Date(owner.LAST_MODIFIED_DATE), 'MM/dd/yyyy'),
      ...(USER_ACCESS_LEVEL_MANAGEMENT
        ? {
            WEB_USER_ACCESS_LEVEL_TYPE_ID: owner
          }
        : {})
    }))
  }
  getAccessEditorCell = owner => {
    const userAccess = [
      { value: 100, label: 'Full access', tooltip: 'Ability to file any online form.' },
      { value: 30, label: 'Basic access', tooltip: 'Ability to file business annual report only.' }
    ].find(x => owner.WEB_USER_ACCESS_LEVEL_TYPE_ID === x.value)

    return (
      <div className="flex-row">
        { SHOW_ACCESS_LEVEL_TYPE_DROPDOWN ? 
        <Select
          value={owner.WEB_USER_ACCESS_LEVEL_TYPE_ID}
          options={[
            { value: 100, label: 'Full access' },
            { value: 30, label: 'Basic access' },
            // { value: 20, label: 'Logged in access' },
            // { value: 10, label: 'Public (No login required)' }
          ]}
          disabled={
            this.state.accessSelectDisabled ||
            owner.WEB_USER_ID === this.props.currentUserId ||
            this.state.currentOwnerAccessLevel !== 100
          }
          onBlur={() => {}}
          onChange={typeId =>
            this.setAccessLevel({
              RECORD_ID: owner.WEB_USER_ACCESS_ID,
              WEB_USER_ACCESS_LEVEL_TYPE_ID: typeId
            })
          }
        /> :
        <div>{userAccess.label}
        </div>
  }
        <a data-tip={userAccess.tooltip} className="tip">i</a>
        <ReactTooltip place="bottom" effect="float" type="none" className="tooltip-wrapper"/>
      </div>
    )
  }
  setAccessLevel = payload => {
    this.setState({ accessSelectDisabled: true })
    SET_WEB_USER_ACCESS_LEVEL(
      payload,
      () => {
        this.getWebUserAccessList()
      },
      err => {
        this.setState({ accessSelectDisabled: false })
        console.error(err)
      }
    )
  }
  rejectRequest = row => {
    REJECT_RECORD_ACCESS_REQUEST(row.WEB_USER_ACCESS_ID, successful => {
      if (successful) {
        this.setState({ owners: null })
        this.getWebUserAccessList()
      }
    })
  }
  acceptRequest = row => {
    ACCEPT_RECORD_ACCESS_REQUEST(row.WEB_USER_ACCESS_ID, successful => {
      if (successful) {
        this.setState({ owners: null })
        this.getWebUserAccessList()
      }
    })
  }
  startRevokeAccess = row => {
    this.props.onOpenRevokeDialog && this.props.onOpenRevokeDialog()
    this.setState({
      revokeDialogOpen: true,
      revokingName: row.FULL_NAME,
      revokingOwnAccess: row.WEB_USER_ID === this.props.currentUserId,
      revokingId: row.WEB_USER_ACCESS_ID
    })
  }
  revokeAccess = () => {
    REVOKE_RECORD_ACCESS(this.state.revokingId, successful => {
      if (successful) {
        this.setState({ revokingId: null })
        if (this.state.revokingOwnAccess) {
          this.props.onAccessRevoked()
          // this.props.onRequestModalClose()
        } else {
          this.getWebUserAccessList()
        }
      } else {
        this.setState({
          revokingId: null,
          error: 'Something went wrong while trying to revoke access. Try again later.'
        })
      }
    })
  }
  closeRevokeDialog = () => {
    this.setState({ revokeDialogOpen: false, revokingName: '', revokingOwnAccess: false })
    this.props.onCloseRevokeDialog && this.props.onCloseRevokeDialog()
  }
  render() {
    const ACTION_MAP = {
      Accepted: (row) => {
        // If ALLOW_REVOKE_OWN_ACCESS_ONLY is true, only allow the user to revoke their own access.
        return !ALLOW_REVOKE_OWN_ACCESS_ONLY || row.WEB_USER_ID === this.props.currentUserId
        ?
          [
            {
              label: <span>Revoke</span>,
              className: 'primary',
              hideLabel: false,
              tooltip: false,
              style: 'inner',
              onClick: this.startRevokeAccess
            }
          ]
        :
          null
      },
      Requested: [
        {
          label: (
            <span>
              <span className="icon icon-check" /> Accept
            </span>
          ),
          className: 'success',
          hideLabel: false,
          tooltip: false,
          style: 'inner',
          onClick: this.acceptRequest
        },
        {
          label: (
            <span>
              <span className="icon icon-cross" /> Reject
            </span>
          ),
          className: 'danger',
          hideLabel: false,
          tooltip: false,
          style: 'inner',
          onClick: this.rejectRequest
        }
      ]
    }
    return (
      <div className="ownership">
        {this.state.error && <p className="error">{this.state.error}</p>}
        {this.state.owners ? (
          <Table
            template={[
              { label: 'User', id: 'FULL_NAME' },
              { label: 'Status', id: 'STATUS' },
              { label: 'Date', id: 'LAST_MODIFIED_DATE' },
              ...(USER_ACCESS_LEVEL_MANAGEMENT
                ? [
                    {
                      label: 'Access Level',
                      id: 'WEB_USER_ACCESS_LEVEL_TYPE_ID',
                      render: this.getAccessEditorCell
                    }
                  ]
                : [])
            ]}
            rows={this.state.owners}
            className="center-container"
            onCellClick={null}
            actionCell={true}
            actionMap={ACTION_MAP}
            actionCellClassName="ownership-action-cell"
            selectedRowIndex={null}
            animated={false}
            firstCellInteractive={false}
          />
        ) : (
          <div>
            <Spinner themeColor="medium-neutral-color" />
          </div>
        )}
        <Portal isOpened={this.state.revokeDialogOpen}>
          <ConfirmDialog
            closeModal={this.closeRevokeDialog}
            message={`Are you sure you want to revoke ${
              this.state.revokingOwnAccess
                ? 'your own access to this record? To manage this record, you'
                : `${this.state.revokingName}'s access to this record? To become an owner, they`
            } will be required to request access again.`}
            buttons={[
              { label: 'No', onClick: noop, className: 'btn-default' },
              { label: 'Yes', onClick: this.revokeAccess, className: 'btn-danger' }
            ]}
            modalStyle={{ borderRadius: 3 }}
          />
        </Portal>
      </div>
    )
  }
}
export default (Ownership = connect(state => ({
  currentUserId: state.auth.WEB_USER_ID
}))(Ownership))



// WEBPACK FOOTER //
// ./src/components/MyRecords/Ownership.js